// extracted by mini-css-extract-plugin
export var container = "left_layout-module--container--1x6ug";
export var wrapper = "left_layout-module--wrapper--qE9bX";